import React from "react";
import "./App.css";
import Homepage from "./feature/pages/homepage/Homepage";

function App() {
  return (
    <div className="App">
      <Homepage />
    </div>
  );
}

export default App;
